import React from 'react';
import { Button, Input, Dropdown } from 'semantic-ui-react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import $ from "jquery";
import Server from '../../functions/server';
import Loading from '../loading';
import ReadCookie from '../../functions/readcookies';

class AddCustomerType extends React.Component {

  state = {
    status: 'Active', maxWidth: 'sm'
  }

  addOrEdit() {
      if (this.props.type == 'edit') {
          this.setState({ open: true, status: this.props.item.status, name: this.props.item.type_name })
      }
      else {
          this.setState({ open: true })
      }
  }

  type = (f, { value }) => {
    this.setState({ status: value })
  }

  onChangeTextBox = name => event => { this.setState({ [name]: event.target.value }); }

  save() {
      let context = this;
      let cook = (ReadCookie("vaigai"));
      let id = cook.id;
      let url = Server() + 'customertype/add.php';
      let data = { 'id': id, 'name': context.state.name, 'status': context.state.status };
      if (this.props.type == 'edit') {
        id = context.props.item.id;
        url = Server() + 'customertype/changestatus.php';
        data = { 'id': id, 'name': context.state.name, 'status': context.state.status };
      }
      $.ajax({
        type: 'POST', data, url,
        success: function(data) {
            if (data == 1) {
                context.props.getCustomerType();
                context.setState({ open: false, status: 'Active', name: '' })
            }
            else {
                alert('failed');
                context.setState({ load: false })
            }
        },
        error: function(e) {
          context.setState({ load: false });
        }
      });
  }

  render() {
      let option = [
          {text: 'Active', key: 'Active', value: 'Active'},
          {text: 'Inactive', key: 'Inactive', value: 'Inactive'}
      ]
    return (
      <div>
        { this.props.type == 'edit' ?
            (<u onClick={this.addOrEdit.bind(this)}>Edit</u>):
            (<Button onClick={this.addOrEdit.bind(this)}>Add</Button>)
        }   
        <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth}  open={this.state.open}
          onClose={ () => { this.setState({ open: false, name: '', status: 'Active' }) }} aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">{'Customer Type'}</DialogTitle>
          <DialogContent>
            <div>
                Type Name<br/>
                <Input fluid value={this.state.name} onChange={this.onChangeTextBox('name')} /><br/>
                Status<br/>
                <Dropdown onChange={this.type} selection
                    options={option} value={this.state.status} />
            </div>
            <br/><br/><br/>
          </DialogContent>
          <DialogActions>
              <Button onClick={ () => { this.setState({ open: false, name: '', status: 'Active' }) }}>Close</Button>
              <Button onClick={this.save.bind(this)}>Save</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default AddCustomerType;
